import logo from './logo.svg';

import tricia from './imgs/tricia.png';

import React, {useState} from "react";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Image from 'react-bootstrap/Image';
import Stack from 'react-bootstrap/Stack';

import './App.scss';

import { LoginForm } from './LoginForm.js';
import { SignUp } from './SignUp.js';
import { ProfilePage } from './ProfilePage.js';
import { InstructionsPage } from './InstructionsPage.js';

// ======================= FIREBASE SETUP =======================
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail, setPersistence, onAuthStateChanged, signOut, inMemoryPersistence, updateEmail, updatePassword } from "firebase/auth";
import { getFirestore, collection, doc, setDoc, getDoc, addDoc, getDocs, query, where, orderBy, deleteDoc, updateDoc, arrayUnion, arrayRemove, deleteField, onSnapshot } from "firebase/firestore"; 

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDH3So9LwGlkPO5voYo9fTDG-fSW4clzhY",
  authDomain: "autoleadenter.firebaseapp.com",
  projectId: "autoleadenter",
  storageBucket: "autoleadenter.appspot.com",
  messagingSenderId: "516405126365",
  appId: "1:516405126365:web:3603ff6f0c75b1213fa734",
  measurementId: "G-TE9DP0RDT3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Disable login persistence
// setPersistence(auth, inMemoryPersistence)

// ======================= END FIREBASE SETUP =======================

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function TopNav(props) {

  let rightNavContent = <>
    <Nav.Link onClick={()=>{props.changePage('sign-up')}}>Sign Up</Nav.Link>
    <Nav.Link onClick={()=>{props.changePage('login')}}>Login</Nav.Link>
  </>;

  if(props.user !== undefined) {
    rightNavContent = <>
      <Nav.Link onClick={()=>{props.changePage('profile')}}>Account</Nav.Link>
      <Nav.Link onClick={()=>{props.changePage('instructions')}}>Setup</Nav.Link>
      <Nav.Link onClick={()=>{signUserOut()}}>Sign Out</Nav.Link>
    </>
  }

  return(
    <Navbar bg="primary" variant="dark" sticky="top">
      <Container>
        <Navbar.Brand onClick={()=>{props.changePage('home')}}>
          <svg width="194" height="38" viewBox="0 0 194 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.2138 0.889951C29.8718 0.33684 29.2675 0 28.6173 0H1.87654C0.840222 0 0 0.840222 0 1.87654C0 2.91286 0.840222 3.75309 1.87654 3.75309H25.581L24.6428 5.62963H5.16049C4.51027 5.62963 3.90602 5.96647 3.56402 6.51958C3.22202 7.07269 3.19106 7.76326 3.48193 8.34546L6.29674 13.9751C6.61481 14.6108 7.26457 15.0123 7.97531 15.0123H20.4205L19.4823 16.8889H10.7901C10.1399 16.8889 9.53565 17.2257 9.19365 17.7788C8.85165 18.3319 8.82069 19.0225 9.11156 19.6047L11.9264 25.2343C12.2444 25.87 12.8942 26.2716 13.6049 26.2716H15.1071L14.31 27.7062C14.1552 27.9844 14.0741 28.2983 14.0741 28.6173V31.1942H12.0211L15.9501 38L19.8801 31.1942H17.8272V29.1033L19.9369 25.3061C20.2596 24.7253 20.2507 24.0165 19.9139 23.4432C19.577 22.8699 18.9611 22.5185 18.2963 22.5185H14.7646L13.8264 20.642H20.642C21.3527 20.642 22.0025 20.2404 22.3205 19.6047L25.1354 13.9751C25.4262 13.3934 25.3953 12.7023 25.0533 12.1492C24.7113 11.5961 24.107 11.2593 23.4568 11.2593H9.13501L8.19674 9.38272H25.8025C26.5132 9.38272 27.163 8.98114 27.481 8.34546L30.2959 2.71583C30.5867 2.1341 30.5553 1.44306 30.2138 0.889951Z" fill="url(#paint0_linear_705_386)"/>
            <path d="M47.572 24.2871H52.2012C52.2012 25.0006 52.1566 25.6116 52.0674 26.12C51.9782 26.6285 51.6928 27.0655 51.2112 27.4312C50.7295 27.7969 50.0962 27.9797 49.3113 27.9797H43.2639C42.4968 27.9797 41.8903 27.7568 41.4444 27.3108C40.9984 26.8648 40.7754 26.2583 40.7754 25.4912V9.62349L40.9627 9.43618H42.5414C44.2183 9.43618 45.0567 10.346 45.0567 12.1655V24.3941C45.8416 24.3228 46.6801 24.2871 47.572 24.2871ZM58.9711 22.4943L58.9443 24.4209V24.4476C59.7649 24.412 60.425 24.3941 60.9245 24.3941H67.1324C67.1324 25.0542 67.1056 25.5626 67.0521 25.9194C66.8381 27.293 65.9283 27.9797 64.3228 27.9797H57.205C56.438 27.9797 55.8359 27.7568 55.3989 27.3108C54.9618 26.8648 54.7433 26.2583 54.7433 25.4912V9.8108L54.9306 9.62349H66.4634C66.5705 10.1408 66.624 10.7027 66.624 11.3093C66.624 11.9158 66.4991 12.5491 66.2494 13.2091H58.9443L58.9711 15.1357V17.0088C59.4349 16.991 60.0414 16.982 60.7907 16.982H64.8847C65.0453 17.4815 65.1255 18.0524 65.1255 18.6946C65.1255 19.3368 65.0453 19.9255 64.8847 20.4606H58.9711V22.4943ZM74.5445 24.073C74.0628 24.073 73.706 24.0641 73.4741 24.0463L72.3235 27.9262C71.8954 28.0333 71.2978 28.0868 70.5307 28.0868C69.6745 28.0868 68.9787 27.9887 68.4436 27.7924L68.3098 27.5784L74.1966 9.62349C74.8923 9.51646 75.704 9.46294 76.6316 9.46294C77.6841 9.46294 78.5226 9.52538 79.1469 9.65025L84.9267 27.6319C84.3024 27.9708 83.5977 28.1403 82.8128 28.1403C81.8852 28.1403 81.2341 27.9797 80.8595 27.6586C80.4848 27.3375 80.1637 26.7221 79.8962 25.8123L79.3877 24.0463C79.1558 24.0641 78.808 24.073 78.3442 24.073H74.5445ZM74.4642 20.7015L75.5345 20.6747H77.4879C77.5771 20.6747 77.7332 20.6792 77.9562 20.6881C78.1792 20.697 78.3442 20.7015 78.4512 20.7015L77.9963 19.0424C77.5682 17.544 77.0776 15.7066 76.5246 13.5302H76.364C76.2213 14.2973 75.7932 16.0009 75.0796 18.6411L74.4642 20.7015ZM99.0016 26.7221C98.4308 27.1859 97.6816 27.5249 96.7539 27.7389C95.8263 27.953 94.8006 28.06 93.6767 28.06C93.1237 28.06 92.3254 28.0511 91.2819 28.0333C90.2383 28.0154 88.9316 27.9887 87.3617 27.953L87.1744 27.7657V9.75728L87.3617 9.56997C88.3964 9.5343 89.4712 9.50754 90.5861 9.4897C91.7011 9.47186 92.874 9.46294 94.1049 9.46294C95.6212 9.46294 96.8877 9.70377 97.9046 10.1854C98.9214 10.6671 99.733 11.3271 100.34 12.1655C100.946 13.004 101.374 13.9896 101.624 15.1223C101.874 16.2551 101.999 17.4726 101.999 18.7749C101.999 20.5588 101.793 22.1018 101.383 23.4041C100.973 24.7063 100.179 25.8123 99.0016 26.7221ZM94.0781 24.7152C96.4328 24.7152 97.6102 22.7351 97.6102 18.7749C97.6102 14.7968 96.4328 12.8077 94.0781 12.8077H92.5663C92.5663 12.8077 92.1872 12.7988 91.429 12.781V24.742C91.7501 24.7241 92.1292 24.7152 92.5663 24.7152H94.0781ZM111.096 9.56997C112.541 9.5343 113.777 9.50754 114.802 9.4897C115.828 9.47186 116.653 9.46294 117.278 9.46294C119.222 9.46294 120.752 9.86878 121.867 10.6804C122.982 11.4921 123.539 12.7096 123.539 14.333C123.539 15.1179 123.316 15.8493 122.87 16.5272C122.424 17.205 121.853 17.6956 121.158 17.9989C121.604 18.1416 122.027 18.369 122.429 18.6812C122.83 18.9934 123.173 19.3591 123.459 19.7783C123.744 20.1975 123.972 20.6524 124.141 21.143C124.311 21.6336 124.395 22.1375 124.395 22.6548C124.395 24.4922 123.811 25.8525 122.643 26.7355C121.474 27.6185 119.82 28.06 117.679 28.06C117.019 28.06 116.145 28.0511 115.057 28.0333C113.969 28.0154 112.648 27.9887 111.096 27.953L110.909 27.7657V9.75728L111.096 9.56997ZM117.358 19.8452H115.137V25.0631C115.601 25.0452 116.123 25.0452 116.702 25.0631C117.282 25.0809 117.822 25.0363 118.321 24.9293C118.821 24.8223 119.24 24.5636 119.579 24.1533C119.918 23.743 120.087 23.1722 120.087 22.4408C120.087 21.745 119.869 21.1385 119.432 20.6212C118.995 20.1039 118.303 19.8452 117.358 19.8452ZM115.137 12.4866V16.7947H117.037C117.893 16.7947 118.495 16.5851 118.843 16.1659C119.191 15.7467 119.365 15.2338 119.365 14.6273C119.365 14.0208 119.186 13.5168 118.83 13.1155C118.473 12.7141 117.875 12.5134 117.037 12.5134H115.953C115.953 12.5134 115.681 12.5045 115.137 12.4866ZM141.574 9.62349V21.1564C141.574 23.4397 140.95 25.2013 139.701 26.4411C138.452 27.6809 136.669 28.3008 134.349 28.3008C132.03 28.3008 130.242 27.6809 128.984 26.4411C127.727 25.2013 127.098 23.4397 127.098 21.1564V9.62349L127.285 9.43618H128.864C130.559 9.43618 131.406 10.346 131.406 12.1655V21.2099C131.406 22.4586 131.629 23.3862 132.075 23.9927C132.521 24.5993 133.279 24.9025 134.349 24.9025C135.42 24.9025 136.178 24.5993 136.624 23.9927C137.07 23.3862 137.293 22.4586 137.293 21.2099V9.62349C137.846 9.51646 138.559 9.46294 139.434 9.46294C140.29 9.46294 141.003 9.51646 141.574 9.62349ZM157.201 26.7221C156.63 27.1859 155.881 27.5249 154.953 27.7389C154.026 27.953 153 28.06 151.876 28.06C151.323 28.06 150.525 28.0511 149.481 28.0333C148.438 28.0154 147.131 27.9887 145.561 27.953L145.374 27.7657V9.75728L145.561 9.56997C146.596 9.5343 147.671 9.50754 148.786 9.4897C149.901 9.47186 151.073 9.46294 152.304 9.46294C153.821 9.46294 155.087 9.70377 156.104 10.1854C157.121 10.6671 157.933 11.3271 158.539 12.1655C159.146 13.004 159.574 13.9896 159.823 15.1223C160.073 16.2551 160.198 17.4726 160.198 18.7749C160.198 20.5588 159.993 22.1018 159.583 23.4041C159.172 24.7063 158.379 25.8123 157.201 26.7221ZM152.278 24.7152C154.632 24.7152 155.81 22.7351 155.81 18.7749C155.81 14.7968 154.632 12.8077 152.278 12.8077H150.766C150.766 12.8077 150.387 12.7988 149.629 12.781V24.742C149.95 24.7241 150.329 24.7152 150.766 24.7152H152.278ZM175.049 26.7221C174.478 27.1859 173.729 27.5249 172.801 27.7389C171.874 27.953 170.848 28.06 169.724 28.06C169.171 28.06 168.373 28.0511 167.329 28.0333C166.286 28.0154 164.979 27.9887 163.409 27.953L163.222 27.7657V9.75728L163.409 9.56997C164.444 9.5343 165.519 9.50754 166.633 9.4897C167.748 9.47186 168.921 9.46294 170.152 9.46294C171.669 9.46294 172.935 9.70377 173.952 10.1854C174.969 10.6671 175.78 11.3271 176.387 12.1655C176.993 13.004 177.422 13.9896 177.671 15.1223C177.921 16.2551 178.046 17.4726 178.046 18.7749C178.046 20.5588 177.841 22.1018 177.43 23.4041C177.02 24.7063 176.226 25.8123 175.049 26.7221ZM170.125 24.7152C172.48 24.7152 173.658 22.7351 173.658 18.7749C173.658 14.7968 172.48 12.8077 170.125 12.8077H168.614C168.614 12.8077 168.235 12.7988 167.476 12.781V24.742C167.797 24.7241 168.177 24.7152 168.614 24.7152H170.125ZM187.438 14.1457L189.231 9.62349C189.695 9.51646 190.292 9.46294 191.024 9.46294C191.809 9.46294 192.487 9.56997 193.057 9.78404L193.245 9.99811L188.054 22.2802V27.8995C187.501 28.0065 186.787 28.06 185.913 28.06C185.039 28.06 184.325 28.0065 183.772 27.8995V22.1732L178.608 10.1319C179.428 9.65025 180.213 9.40942 180.963 9.40942C181.712 9.40942 182.251 9.53876 182.581 9.79742C182.911 10.0561 183.201 10.4976 183.451 11.122L184.736 14.3062C185.199 15.4479 185.601 16.7234 185.94 18.1327H186.1C186.386 17.0088 186.832 15.6798 187.438 14.1457Z" fill="url(#paint1_linear_705_386)"/>
            <defs>
            <linearGradient id="paint0_linear_705_386" x1="0" y1="0" x2="0" y2="38" gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#F8EFBA"/>
            </linearGradient>
            <linearGradient id="paint1_linear_705_386" x1="40.7754" y1="9.40942" x2="40.7754" y2="28.3008" gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#F8EFBA"/>
            </linearGradient>
            </defs>
          </svg>
        </Navbar.Brand>
        <Nav className="justify-content-end">
          {rightNavContent}
        </Nav>
      </Container>
    </Navbar>
  );
}

function Footer(props) {

  let navLinks = <>
    <Nav.Link onClick={()=>{props.changePage('sign-up')}} className="p-0 pt-2">Sign Up</Nav.Link>
    <Nav.Link onClick={()=>{props.changePage('login')}} className="p-0 pt-2">Login</Nav.Link>
  </>;

  if(props.user !== undefined) {
    navLinks = <>
      <Nav.Link onClick={()=>{props.changePage('profile')}} className="p-0 pt-2">Account</Nav.Link>
      <Nav.Link onClick={()=>{props.changePage('instructions')}} className="p-0 pt-2">Setup</Nav.Link>
      <Nav.Link onClick={()=>{signUserOut()}} className="p-0 pt-2">Sign Out</Nav.Link>
    </>;
  }

  return(
    <footer className="p-5 bg-light text-dark" sticky="bottom">
      <Container>
        <Row>
          <Col>
            <h6>Links</h6>
            <Nav defaultActiveKey="#home" className="flex-column">
              {navLinks}
            </Nav>    
          </Col>
          <Col>
          </Col>
          <Col>
            <h6>Contact</h6>
              <Row>
                <Col>
                  <a href="mailTo:contact@leadbuddy.ca">contact@leadbuddy.ca</a>
                </Col>
              </Row>
              <Row>
                <Col>
                  <a href="tel:250 686 3065">250 686 3065</a>
                </Col>
              </Row>          
          </Col>
        </Row>
        <br/>
        <Row>
          <Col className="text-center">
          Copyright © 2023 Lead Buddy Technologies Ltd.
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

function HomePage(props) {

  let signUpButton = <>
    <Button variant="primary" size="md" onClick={()=>{props.changePage('sign-up')}}>
      Sign Up
    </Button>
  </>;

  let heroButtons = <>
    <Button variant="primary" size="lg" onClick={()=>{props.changePage('sign-up')}}>
      Sign Up
    </Button>
    <Button variant="secondary" size="lg" onClick={()=>{props.changePage('login')}}>
      Login
    </Button>
  </>;


  if(props.user !== undefined) {
    heroButtons = <>
      <Button variant="secondary" size="lg" onClick={()=>{props.changePage('profile')}}>
        Account
      </Button>
      <Button variant="secondary" size="lg" onClick={()=>{signUserOut()}}>
        Sign Out
      </Button>
    </>

    signUpButton = <></>;
  }


  return (
    <>
      <div id="hero" className="p-5 text-light fade-in fill-out-height">
        <Container>
          <Row>
            <Col>
              <h1 className="hero_title text-center">
                <svg style={{maxWidth: "100%", minWidth: "256px"}} width="550" height="108" viewBox="0 0 550 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M85.8707 2.52933C84.8987 0.957334 83.1813 0 81.3333 0H5.33333C2.388 0 0 2.388 0 5.33333C0 8.27867 2.388 10.6667 5.33333 10.6667H72.704L70.0373 16H14.6667C12.8187 16 11.1013 16.9573 10.1293 18.5293C9.15733 20.1013 9.06933 22.064 9.896 23.7187L17.896 39.7187C18.8 41.5253 20.6467 42.6667 22.6667 42.6667H58.0373L55.3707 48H30.6667C28.8187 48 27.1013 48.9573 26.1293 50.5293C25.1573 52.1013 25.0693 54.064 25.896 55.7187L33.896 71.7187C34.8 73.5253 36.6467 74.6667 38.6667 74.6667H42.936L40.6707 78.744C40.2307 79.5347 40 80.4267 40 81.3333V88.6573H34.1653L45.332 108L56.5013 88.6573H50.6667V82.7147L56.6627 71.9227C57.58 70.272 57.5547 68.2573 56.5973 66.628C55.64 64.9987 53.8893 64 52 64H41.9627L39.296 58.6667H58.6667C60.6867 58.6667 62.5333 57.5253 63.4373 55.7187L71.4373 39.7187C72.264 38.0653 72.176 36.1013 71.204 34.5293C70.232 32.9573 68.5147 32 66.6667 32H25.9627L23.296 26.6667H73.3333C75.3533 26.6667 77.2 25.5253 78.104 23.7187L86.104 7.71867C86.9307 6.06533 86.8413 4.10133 85.8707 2.52933Z" fill="url(#paint0_linear_705_381)"/>
                  <path d="M135.203 69.0268H148.36C148.36 71.0548 148.233 72.7913 147.98 74.2362C147.726 75.6812 146.915 76.9234 145.546 77.9627C144.177 79.0021 142.378 79.5217 140.147 79.5217H122.959C120.779 79.5217 119.055 78.888 117.788 77.6205C116.52 76.353 115.887 74.6292 115.887 72.4491V27.3513L116.419 26.819H120.906C125.672 26.819 128.055 29.4047 128.055 34.5761V69.331C130.286 69.1282 132.668 69.0268 135.203 69.0268ZM167.601 63.9315L167.525 69.4071V69.4831C169.857 69.3817 171.733 69.331 173.152 69.331H190.796C190.796 71.2069 190.72 72.6519 190.568 73.6659C189.96 77.5698 187.374 79.5217 182.811 79.5217H162.582C160.401 79.5217 158.69 78.888 157.448 77.6205C156.206 76.353 155.585 74.6292 155.585 72.4491V27.8837L156.117 27.3513H188.895C189.199 28.8216 189.351 30.4187 189.351 32.1425C189.351 33.8663 188.996 35.6661 188.286 37.542H167.525L167.601 43.0177V48.3412C168.919 48.2905 170.643 48.2651 172.772 48.2651H184.408C184.864 49.6847 185.092 51.3071 185.092 53.1323C185.092 54.9575 184.864 56.6306 184.408 58.1516H167.601V63.9315ZM211.862 68.4184C210.493 68.4184 209.479 68.3931 208.82 68.3424L205.55 79.3696C204.333 79.6738 202.635 79.8259 200.454 79.8259C198.021 79.8259 196.044 79.5471 194.523 78.9894L194.142 78.381L210.873 27.3513C212.851 27.0471 215.158 26.895 217.794 26.895C220.785 26.895 223.168 27.0725 224.943 27.4274L241.369 78.5331C239.595 79.4964 237.592 79.978 235.362 79.978C232.725 79.978 230.875 79.5217 229.81 78.6091C228.745 77.6965 227.833 75.9474 227.072 73.3617L225.627 68.3424C224.968 68.3931 223.979 68.4184 222.661 68.4184H211.862ZM211.634 58.8361L214.676 58.76H220.228C220.481 58.76 220.925 58.7727 221.558 58.7981C222.192 58.8234 222.661 58.8361 222.965 58.8361L221.672 54.121C220.456 49.8622 219.061 44.6401 217.49 38.4546H217.033C216.628 40.6348 215.411 45.4766 213.383 52.9802L211.634 58.8361ZM281.372 75.9474C279.749 77.2656 277.62 78.2289 274.984 78.8373C272.347 79.4457 269.432 79.7499 266.238 79.7499C264.666 79.7499 262.397 79.7245 259.431 79.6738C256.465 79.6231 252.752 79.5471 248.29 79.4457L247.758 78.9133V27.7316L248.29 27.1992C251.231 27.0978 254.285 27.0218 257.454 26.9711C260.623 26.9204 263.956 26.895 267.455 26.895C271.764 26.895 275.364 27.5795 278.254 28.9484C281.144 30.3173 283.451 32.1932 285.174 34.5761C286.898 36.959 288.115 39.7602 288.825 42.9796C289.535 46.1991 289.889 49.6594 289.889 53.3605C289.889 58.4305 289.306 62.816 288.14 66.5172C286.974 70.2183 284.718 73.3617 281.372 75.9474ZM267.379 70.2436C274.071 70.2436 277.417 64.6159 277.417 53.3605C277.417 42.0544 274.071 36.4013 267.379 36.4013H263.082C263.082 36.4013 262.004 36.3759 259.85 36.3252V70.3197C260.762 70.269 261.84 70.2436 263.082 70.2436H267.379ZM315.747 27.1992C319.853 27.0978 323.364 27.0218 326.279 26.9711C329.195 26.9204 331.54 26.895 333.314 26.895C338.84 26.895 343.188 28.0484 346.357 30.3553C349.525 32.6622 351.11 36.1224 351.11 40.7362C351.11 42.967 350.476 45.0457 349.209 46.9723C347.941 48.8989 346.319 50.2931 344.341 51.155C345.609 51.5606 346.813 52.2071 347.954 53.0943C349.095 53.9816 350.071 55.0209 350.882 56.2124C351.693 57.4038 352.339 58.6967 352.821 60.0909C353.303 61.4852 353.543 62.9174 353.543 64.3878C353.543 69.6099 351.883 73.4757 348.562 75.9854C345.241 78.4951 340.539 79.7499 334.455 79.7499C332.579 79.7499 330.095 79.7245 327.002 79.6738C323.909 79.6231 320.157 79.5471 315.747 79.4457L315.214 78.9133V27.7316L315.747 27.1992ZM333.542 56.4025H327.23V71.2323C328.548 71.1816 330.031 71.1816 331.679 71.2323C333.327 71.283 334.86 71.1562 336.28 70.852C337.7 70.5478 338.891 69.8127 339.854 68.6466C340.818 67.4805 341.299 65.8581 341.299 63.7794C341.299 61.802 340.678 60.0782 339.436 58.6079C338.194 57.1376 336.229 56.4025 333.542 56.4025ZM327.23 35.4887V47.7328H332.63C335.063 47.7328 336.774 47.137 337.763 45.9456C338.752 44.7541 339.246 43.2965 339.246 41.5727C339.246 39.8489 338.739 38.4166 337.725 37.2759C336.711 36.1351 335.013 35.5647 332.63 35.5647H329.55C329.55 35.5647 328.776 35.5394 327.23 35.4887ZM402.368 27.3513V60.1289C402.368 66.6186 400.593 71.6252 397.044 75.1488C393.495 78.6725 388.425 80.4343 381.834 80.4343C375.243 80.4343 370.16 78.6725 366.586 75.1488C363.012 71.6252 361.225 66.6186 361.225 60.1289V27.3513L361.757 26.819H366.244C371.06 26.819 373.469 29.4047 373.469 34.5761V60.281C373.469 63.8301 374.102 66.4665 375.37 68.1903C376.637 69.9141 378.792 70.776 381.834 70.776C384.876 70.776 387.031 69.9141 388.298 68.1903C389.566 66.4665 390.2 63.8301 390.2 60.281V27.3513C391.771 27.0471 393.799 26.895 396.284 26.895C398.717 26.895 400.745 27.0471 402.368 27.3513ZM446.781 75.9474C445.159 77.2656 443.029 78.2289 440.393 78.8373C437.756 79.4457 434.841 79.7499 431.647 79.7499C430.075 79.7499 427.806 79.7245 424.84 79.6738C421.875 79.6231 418.161 79.5471 413.699 79.4457L413.167 78.9133V27.7316L413.699 27.1992C416.64 27.0978 419.694 27.0218 422.863 26.9711C426.032 26.9204 429.365 26.895 432.864 26.895C437.173 26.895 440.773 27.5795 443.663 28.9484C446.553 30.3173 448.86 32.1932 450.583 34.5761C452.307 36.959 453.524 39.7602 454.234 42.9796C454.944 46.1991 455.299 49.6594 455.299 53.3605C455.299 58.4305 454.716 62.816 453.549 66.5172C452.383 70.2183 450.127 73.3617 446.781 75.9474ZM432.788 70.2436C439.48 70.2436 442.826 64.6159 442.826 53.3605C442.826 42.0544 439.48 36.4013 432.788 36.4013H428.491C428.491 36.4013 427.414 36.3759 425.259 36.3252V70.3197C426.171 70.269 427.249 70.2436 428.491 70.2436H432.788ZM497.506 75.9474C495.884 77.2656 493.755 78.2289 491.118 78.8373C488.482 79.4457 485.567 79.7499 482.372 79.7499C480.801 79.7499 478.532 79.7245 475.566 79.6738C472.6 79.6231 468.886 79.5471 464.425 79.4457L463.892 78.9133V27.7316L464.425 27.1992C467.365 27.0978 470.42 27.0218 473.589 26.9711C476.757 26.9204 480.091 26.895 483.589 26.895C487.899 26.895 491.498 27.5795 494.388 28.9484C497.278 30.3173 499.585 32.1932 501.309 34.5761C503.033 36.959 504.25 39.7602 504.959 42.9796C505.669 46.1991 506.024 49.6594 506.024 53.3605C506.024 58.4305 505.441 62.816 504.275 66.5172C503.109 70.2183 500.853 73.3617 497.506 75.9474ZM483.513 70.2436C490.206 70.2436 493.552 64.6159 493.552 53.3605C493.552 42.0544 490.206 36.4013 483.513 36.4013H479.216C479.216 36.4013 478.139 36.3759 475.984 36.3252V70.3197C476.897 70.269 477.974 70.2436 479.216 70.2436H483.513ZM532.718 40.2038L537.813 27.3513C539.131 27.0471 540.83 26.895 542.908 26.895C545.139 26.895 547.066 27.1992 548.688 27.8076L549.221 28.416L534.467 63.3231V79.2936C532.895 79.5978 530.867 79.7499 528.383 79.7499C525.898 79.7499 523.87 79.5978 522.299 79.2936V63.0189L507.621 28.7963C509.953 27.4274 512.184 26.7429 514.313 26.7429C516.443 26.7429 517.977 27.1105 518.915 27.8456C519.852 28.5808 520.676 29.8356 521.386 31.6101L525.037 40.6601C526.355 43.9049 527.496 47.53 528.459 51.5353H528.915C529.726 48.3412 530.994 44.564 532.718 40.2038Z" fill="url(#paint1_linear_705_381)"/>
                  <defs>
                  <linearGradient id="paint0_linear_705_381" x1="0" y1="0" x2="0" y2="108" gradientUnits="userSpaceOnUse">
                  <stop offset="1" stopColor="#F8EFBA"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_705_381" x1="115.887" y1="26.7429" x2="115.887" y2="80.4343" gradientUnits="userSpaceOnUse">
                  <stop offset="1" stopColor="#F8EFBA"/>
                  </linearGradient>
                  </defs>
                </svg>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="hero_subtitle text-center">Optimize your home buyer lead generation</p>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col className="hero_buttons">
              {heroButtons}
            </Col>
          </Row>
        </Container>
      </div>

      <div className="m-3 m-md-5">
        <br/>
        <br/>
        <Container>
          <Row>
            <Col style={{minWidth: "15rem"}} className="mb-5 mb-sm-3 mb-md-2 mb-lg-0">
              <h3>
                Focus on what is important
              </h3>
              <br/>

              <p>
                Cutting-edge solution designed to optimize your
                time and prioritize what truly matters: establishing valuable client
                connections and dedicating more quality time to what matters to you.
              </p>
            </Col>
            <Col style={{minWidth: "15rem"}} className="mb-5 mb-sm-3 mb-md-2 mb-lg-0">
              <h3>
                Instant lead follow up
              </h3>
              <br/>

              <p>
                Operate with immediate responsiveness. The moment a
                lead is received, Lead Buddy swiftly and flawlessly ensures its setup
                within a matter of seconds.
              </p>          
            </Col>
            <Col style={{minWidth: "15rem"}} className="mb-5 mb-sm-3 mb-md-2 mb-lg-0">
              <h3>
                Unparalleled compatibility
              </h3>
              <br/>
              <p>
              Seamless integration with a wide range of lead
              generation systems, effortlessly incorporating leads into your MLS
              interface. This integration guarantees the immediate implementation of
              leads with unparalleled efficiency, delivering optimal results for
              your business.
              </p>           
            </Col>
          </Row>
        </Container>
        <br/>
        <br/>
      </div>

      <div className="m-3 m-md-5">
        <Container>
          <Row>
            <Col>
              <h3 style={{textAlign:"center"}}>
                Subscription Options
                <br/>
                <br/>
                <br/>

              </h3>
            </Col>
          </Row>
          <Row>
            <Col md={{ span: 4, offset: 2 }}>
              <Card
                bg='light'
                key='monthly'
                text='dark'
                className="mb-2"
              >
                <Card.Header>Monthly</Card.Header>
                <Card.Body>
                  <Card.Title>$30 </Card.Title>
                  <Card.Text>
                    Dive into the world of automating your lead generation workflow with our flexible monthly membership. 
                    For just $30 per month, you can harness the full potential of Lead Buddy's features and turbocharge your business growth.
                  </Card.Text>
                  {signUpButton}
                </Card.Body>
              </Card>
            </Col>
            <Col md={{ span: 4, offset: 0 }}>
              <Card
                bg='light'
                key='yearly'
                text='dark'
                className="mb-2"
              >
                <Card.Header>Yearly</Card.Header>
                <Card.Body>
                  <Card.Title>$324 (<i>10% discount</i>) </Card.Title>
                  <Card.Text>
                    Looking for even more value? Opt for our annual membership at just $324 per year, and you'll save a fantastic 10%! 
                    That's 12 months of unlimited lead automation, seamless integration, and support, all at a discounted rate.                  
                  </Card.Text>
                  {signUpButton}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <br/>
        <br/>
      </div>

      <div className="m-3 m-md-5">
        <br/>
        <br/>
        <Container>
          <Row>
            <Col md={{ span: 10, offset: 1 }}>
              <h3>
                Why develop Lead Buddy?
              </h3>
              <br/>
              <p>
                <i>
                "The conception of this app was born from my personal
                experiences, spanning many years, as I diligently implemented leads
                into my MLS system. Every time a lead arrived, regardless of the
                activity or hour, I was compelled to pause and attend to its setup. In
                our industry, it is often said that the first to respond has a higher
                probability of turning that lead into a client. After enduring
                numerous disruptions in both my personal and professional life, I
                resolved to create what is now known as Lead Buddy. Lead Buddy becomes
                your steadfast companion in the realm of real estate. Your loved ones
                will express their gratitude! As an agent with over 13 years of
                experience, I can confidently say that this app has been an absolute
                blessing and game-changer."
                </i>
                <br/>
              </p>
              <br/>

              <Stack gap={5} className="col-md-5 mx-auto text-align-center justify-content-center align-items-center">
                <Image style={{objectFit:"cover", width:"142px", aspectRatio:"1"}} src={tricia} roundedCircle />
                <b> - Tricia Keller (Lead Buddy Co-founder)</b>
              </Stack>
            </Col>
          </Row>
        </Container>
        <br/>
        <br/>
        <br/>
      </div>
    </>
  );
}

function signUserIn(email, password, rememberMe, onLoginError) {
  signInWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    // Signed in 
    const user = userCredential.user;
    onLoginError(undefined);
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(errorCode, errorMessage);
    onLoginError(errorMessage.replace('Firebase:', ''));
  }); 
}

function userResetPassword(email, onError) {
  sendPasswordResetEmail(auth, email)
  .then(() => {
    // Password reset email sent!
    // ..
    onError(undefined);
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    onError(errorMessage.replace('Firebase:', ''));
    console.log(errorCode, errorMessage);
  });
}

function signUserOut() {
  signOut(auth).then(() => {
    // Sign-out successful.
  }).catch((error) => {
    // An error happened.
    console.log(error);
  });
}

function createAccount(profileInfo, onError) {
  createUserWithEmailAndPassword(auth, profileInfo.email, profileInfo.password)
  .then((userCredential) => {
      // Signed in 
      const user = userCredential.user;
      console.log(user);

      setDoc(doc(db, "users", user.uid), {
        leads: [],
        matrix: {
          user_id: ""
        },
        profile: {
          firstname: profileInfo.firstname,
          lastname: profileInfo.lastname,
          phone: profileInfo.phone,
          address : {
            streetAddress: profileInfo.address,
            city: profileInfo.city,
            province: profileInfo.province,
            country: profileInfo.country,
            postalCode: profileInfo.postalCode
          },
          howDidYouHearAboutUs: profileInfo.howDidYouHearAboutUs,
        },
        realtorAssociation: profileInfo.realtorAssociation,
        leadGenerationSystems: profileInfo.leadGenerationSystems,
        accountErrors: []
      })
      .then(() => {
        console.log("New account document successfully written!");
        onError(undefined);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode);
        console.log(errorMessage);
        console.error("Error creating new account document: ", error);
        onError(errorMessage.replace('Firebase:', ''));
      });
  }).catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode);
      console.log(errorMessage);
      onError(errorMessage.replace('Firebase:', ''));
    });
}

function addToWaitingList(profileInfo) { 
  addDoc(collection(db, "waiting_list"), {
    email: profileInfo.email,
    firstname: profileInfo.firstname,
    lastname: profileInfo.lastname,
    phone: profileInfo.phone,
    address : {
      streetAddress: profileInfo.address,
      city: profileInfo.city,
      province: profileInfo.province,
      country: profileInfo.country,
      postalCode: profileInfo.postalCode
    },
    realtorAssociation: profileInfo.realtorAssociation,
    leadGenerationSystems: profileInfo.leadGenerationSystems,
    addedDate: new Date()
  })
  .then(() => {
    console.log("New waiting list document successfully written!");
  })
  .catch((error) => {
    console.error("Error creating new waiting list document: ", error);
  });
}

class App extends React.Component {

  constructor(props) {
    super(props);

    this.changePage = this.changePage.bind(this);
    this.updateMatrix = this.updateMatrix.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.removeAlert = this.removeAlert.bind(this);

    this.state = {
      page: 'home',
      user: undefined,
      firstname : undefined
    };
  }

  removeAlert(alert) {
    const docRef = doc(db, "users", this.state.user.uid);
    console.log(alert);
    // Atomically remove a region from the "regions" array field.
    updateDoc(docRef, {
      accountErrors: arrayRemove(alert)
    });
  }

  updateMatrix(user_id, password) {
      updateDoc(doc(db, "users", this.state.user.uid), {
        matrix: {
          'user_id' : user_id,
        }
      });

      if(password !== undefined || password !== '') {
        setDoc(doc(db, "credentials", this.state.user.uid), {
          matrix: password
        });
      }
  }

  updateProfile(firstname, lastname, email, password) {
    const data = {
      'firstname' : firstname,
      'lastname' : lastname,
    };

    this.setState({
      firstname : firstname,
      lastname : lastname,
      email : email,
    });

    if(email !== undefined && email !== '') {
      updateEmail(auth.currentUser, email).then(() => {
        // Email updated!
        // ...
      }).catch((error) => {
        // An error occurred
        console.log(error);
      });
    }

    if(password !== undefined && password !== '') {
      updatePassword(auth.currentUser, password).then(() => {
        // Password updated!
        // ...
      }).catch((error) => {
        // An error occurred
        console.log(error);
      });
    }

    const docRef = doc(db, "users", this.state.user.uid);
    updateDoc(docRef, {
      profile: data
    });
  }

  changePage(pageName) {
    this.setState({
      page : pageName,
    });
  }

  attemptLoadUserData(user) {
    // Subscribe to user data changes

    const docRef = doc(db, "users", user.uid);

    const unsub = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        console.log(user.uid, ":", docSnap.data());
        let userData = docSnap.data();
        console.log(docSnap);
        this.setState({
          'user' : user,
          firstname : userData.profile.firstname,
          lastname : userData.profile.lastname,
          email : user.email,
          leads : userData.leads,
          matrix_user_id : userData.matrix.user_id,
          accountErrors: userData.accountErrors,
          update_time: docSnap._document.version.timestamp.nanoseconds
        }, () => {
          console.log("Updated state");
          console.log(this.state);
        });

        this.changePage('profile');
      } else {
        // doc.data() will be undefined in this case
        console.log("No such user document!");
      }    
    });
  }

  componentDidMount() {
    console.log('app mounted');

    onAuthStateChanged(auth, (user) => {
      if (user) {
        // https://firebase.google.com/docs/reference/js/firebase.User

        this.attemptLoadUserData(user);
        
      } else {

        if(this.state.user !== undefined) {
          this.changePage('login');
        }

        this.setState({
          user : undefined,
          firstname : undefined,
        });

        console.log('Signed out');
      }
    });
  }

  render() {
    let page = null;

    let nav = <TopNav changePage={this.changePage} user={this.state.user}/>;
    let footer = <Footer changePage={this.changePage} user={this.state.user}/>;

    switch(this.state.page) {
      case 'home':
        page = 
        <>
          {nav}
          <HomePage changePage={this.changePage} user={this.state.user} />
          {footer}
        </>;
        break;

      case 'sign-up':
        page = 
        <>
          {nav}
          <SignUp createAccount={createAccount} addToWaitingList={addToWaitingList}/>
          {footer}
        </>;
        break;

      case 'login':
        page = 
        <>
          {nav}
          <LoginForm onSubmit={signUserIn} onPasswordReset={userResetPassword}/>
          {footer}
        </>;
        break;

      case 'profile':
        page =
        <>
          {nav}
          <ProfilePage user={this.state.user} firstname={this.state.firstname} lastname={this.state.lastname} email={this.state.email} leads={this.state.leads} matrix_user_id={this.state.matrix_user_id} accountErrors={this.state.accountErrors} removeAlert={this.removeAlert} matrix_update_callback={this.updateMatrix} lead_buddy_update_callback={this.updateProfile} onSignOut={signUserOut} viewSetup={()=>{this.changePage('instructions')}}/>
          {footer}
        </>;
        break;

      case 'instructions':
        page =
        <>
          {nav}
          <InstructionsPage userID={this.state.user.uid}/>
          {footer}
        </>
      default:
        break;
    }

    return(
      <div className="App">
        {page}
      </div>
    );
  }
}

export default App;
